import React from 'react';
import classNames from 'classnames/bind';
import { history } from '@store/history';
import styles from './styles.scss';
import PageContainer from 'containers/en/page-container';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';
import { useTranslation } from 'hooks/use-translation';

const cx = classNames.bind(styles);

function JoinUs(props: Record<string, any>) {
	const countryCode = useSelector((state: ConnectState) => state.app.countryCode);
	const path = '/' + (countryCode || 'en');
	const { transData } = useTranslation('forParents');
	const { title, desc, button, title1, list, title2 } = transData;

	return (
		<PageContainer>
			<div className={cx('for-parents')}>
				<div className={cx('banner-wrap')}>
					<div className={cx('banner')} />
					<div className={cx('banner-desc-wrap')}>
						<div className={cx('banner-title')}>{title}</div>
						<div className={cx('banner-desc')}>{desc}</div>
						<div className={cx('banner-btn')} onClick={() => history.push(path)}>
							{button}
						</div>
					</div>
				</div>
				<div className={cx('title')}>{title1}</div>
				<div className={cx('safe-wrap')}>
					{list[0].map((item: any, index: number) => (
						<div key={index} className={cx('safe-item', `safe-item-${index + 1}`)}>
							<div className={cx('icon')}></div>
							<div className={cx('name')}>{item.name}</div>
							<div className={cx('desc')}>{item.desc}</div>
						</div>
					))}
				</div>

				<div className={cx('advantage')}>
					{list[1].map((item: any, index: number) => (
						<div key={index} className={cx('adv-item', `adv-item-${index + 1}`)}>
							<div className={cx('desc-wrap')}>
								<div className={cx('item-title')}>{item.title}</div>
								<div className={cx('item-desc')}>{item.desc}</div>
							</div>
							<div className={cx('item-img')}></div>
						</div>
					))}
				</div>

				<div className={cx('seenin')}>
					<div className={cx('seenin-title')}>{title2}</div>
					<div className={cx('seenin-wrap')}>
						<div className={cx('seenin-item', 'seenin-item-1')} />
						<div className={cx('seenin-item', 'seenin-item-2')} />
						<div className={cx('seenin-item', 'seenin-item-3')} />
					</div>
				</div>
			</div>
		</PageContainer>
	);
}

export default JoinUs;
